<template>
 <div>
          <div class="text-center">
              <b-spinner v-if="loadingData==false" label="Spinning"></b-spinner>
          </div>
   
          <div class="wrapper" id="areaImprimir" v-if="loadingData">
            <b-row class="border-bottom mb-2">
              <b-col>
                <b-img :src="img" left fluid style="max-height: 100px" alt="Responsive image"
                       class="rounded pb-0"></b-img>
                <h1 class="text-right">PLANILLA DESPACHO CONTENEDORES</h1>
                <a href="#" class="float-right text-black-50" @click="descargarPDF" ><i class="fa fa-download"></i></a>
              </b-col>
            </b-row>

              </br>
              <div style="text-align: center;" >
                <h1  v-if="transportDataExportWaybill == undefined" >
                   Debe terminar de ingresar los datos necesarios para poder ver el reporte.
                   </h1>
              </div>
            <b-row>
              
              <b-col cols="2">
                <div class="wrapper-estiva" v-if="exportDataPallet.length > 0 && transportDataExportWaybill != undefined" >
                  <template v-for="palletInfo in exportDataPallet">
                    <div class="box box1" >
                      <span class="font-weight-bold">{{palletInfo.position}} </span><br>
                      {{palletInfo.number}}<br>
                      <small>Tº: {{palletInfo.temperature}} º</small><br>
                      <small>Peso: {{palletInfo.gross_weight}} Kg</small><br>
                      <small>Term: {{palletInfo.temperature_recorder}}</small>
                    </div>
                  </template>
                </div>
              </b-col>
              
              <b-col cols="10" style="padding-left: 45px;"> 
                <div class="wrap">

                  <b-card title="Datos"  v-if="transportDataExportWaybill != undefined" >
                  <p>Fecha Guia Despacho: {{waybill_date}}</p>
                  <p>N° Guia Despacho: {{waybill_number}}</p> 
                  <p>Hora Inicio Carga: {{transportDataExportWaybill.start_time | moment}}</p> 
                  <p>Hora Término Carga: {{transportDataExportWaybill.end_time | moment}}</p> 
                
                </b-card>
                  
                <b-card title="Datos Embarque" v-if="transportDataExportWaybill != undefined" >
                 <p>N° Instructivo Embarque:</b> {{shipmentData.boarding_number}}</p>
                 <p>N° Reserva: {{shipmentData.booking_number}} </p>
                 <p>Naviera: {{shipmentData.shipping_line.name}}</p>
                 <p>Nombre Nave: {{shipmentData.vessel}}</p>
                 <p>Puerto Salida: {{shipmentData.loading_port.name}}</p>
                 <p>Puerto Destino: {{shipmentData.destination_port.name}}</p>
                 <p>Tipo de Embarque: {{shipmentData.shipment_type.name}}</p>
                 <p>N° de Contenedor {{shipmentData.containers}}</p>
                 <p>Recibidor: {{shipmentData.consignee_company.name}}</b> </p>
                 <p>VGM: {{exportWaybill.vgm}}</p>
                 
                </b-card>
             
                <div style="page-break-before: always;">
                
                </div>
                <b-card title="Condicion de transporte" v-if="conditionTransportExport != undefined">
                  <p>Certificado Sanitizacion : {{conditionTransportExport.sanitation_certificate}}</p>
                  <p>Unid. de Frío antes de cargar : {{conditionTransportExport.cold_unit_before_loading}}</p>
                  <p>Limpieza Interior : {{conditionTransportExport.interior_cleaning}}</p>
                  <p>Canales  Ventilación del piso : {{conditionTransportExport.channels_floor_ventilation}}</p>
                  <p>Sellado y Gomas de Puerta : {{conditionTransportExport.sealing_and_door_rubber}}</p>
                  <p>Drenes de líquidos tapados : {{conditionTransportExport.drained_liquid_drains}} </p>
                  <p>Carga bajo la linea roja : {{conditionTransportExport.load_under_the_red_line}}</p>
                  <p>Equipo Autónomo de energía : {{conditionTransportExport.autonomous_energy_equipment}}</p>
                  <p>T° Set Point : {{conditionTransportExport.temperature_set_point}}</p>
                  <p>Cortina de Atmósfera Controlada : {{conditionTransportExport.controlled_atmosphere_curtain}}</p>
                  <p>Sellado con cartones de piso y pallets : {{conditionTransportExport.sealing_with_floorboard_and_pallets}}</p>
                  <p>Sello Naviera : {{conditionTransportExport.shipping_stamp}}</p>
                  <p>Sello Planta : {{conditionTransportExport.seal_plant}}</p>
                </b-card>
                <b-card title="Datos de transporte" v-if="transportDataExportWaybill != undefined">
                  <p>Nombre Chofer : {{transportDataExportWaybill.driver_name}}</p>
                  <p>Tel. Celular : {{transportDataExportWaybill.tel}}</p>
                  <p>Cedula de identidad : {{transportDataExportWaybill.identification_card}}</p>
                  <p>Patente Camión : {{transportDataExportWaybill.truck_patent}}</p>
                  <p>Patente Carro : {{transportDataExportWaybill.patent_car}}</p>
                </b-card>
 
                <b-card title="Observaciones :"  v-if="transportDataExportWaybill != undefined" >
                    {{transportDataExportWaybill.observations}}
                </b-card>
                <b-card title="Responsable :"  v-if="transportDataExportWaybill != undefined" >
                  {{transportDataExportWaybill.responsible}}
                </b-card>
                </div>
              </b-col>
            </b-row>
         </div>
  </div>
</template>

<script>

  import Vue from 'vue'

  import miniToastr from 'mini-toastr'
  import html2pdf from 'html2pdf.js'
  import moment from 'moment';

  const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})
Vue.use(miniToastr);

  export default {
    name: "estibaComponent",
    props: ['waybill','shipment_id','waybill_number','waybill_date'],
    components: {
 
    },
    data() {

      return {
        img: "",
        exportDataPallet:"",
        shipmentData:"",
        exportWaybill:"",
        conditionTransportExport:"",
        transportDataExportWaybill:"",
        loadingData:false,
      }
    },
    filters: {
        moment: function (date) {
          return moment(date).format('DD-MM-YYYY HH:mm');
        },

      },
  watch: {
    waybill: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {

        
        this.$axios.get('/api/comex/shipment/shipping_data_stowage/', {
          params: {
          waybill: this.waybill,
          shipment_id:this.shipment_id,
          }
          })
        .then(res => {

          this.exportDataPallet=res.data.palletsExport;
          this.shipmentData=res.data.shipment[0];
          this.exportWaybill=res.data.exportWaybill[0];
          this.conditionTransportExport = res.data.conditionTransportExport[0];
          this.transportDataExportWaybill = res.data.transportDataExportWaybill[0];

          this.loadingData=true;

        })
        .catch(error => {
            console.log(error)
          });
      
      }
    }
  },
    methods: {
    descargarPDF() {
          const element = document.getElementById('areaImprimir').innerHTML;
          const opt = {
            margin: 0.25,
            image: { type: 'jpeg', quality: 0.5},
            filename: 'Estiba #'+this.waybill+'.pdf',
            // html2canvas: { dpi: 192, letterRendering: true },
            jsPDF: {unit: 'in', format: 'letter', orientation: 'landscape'}
          };
          html2pdf(element, opt);
        }
    },
   mounted() {
      this.img = this.$store.getters.user.IMAGE;
    }
  }
</script>
<style type="text/css">
  .box {
    background-color: #e7e7e7;
    border: solid 1px #444;
    border-radius: 3px;
    padding: 10px;
    font-size: 120%;
    
  }

  .box:nth-child(even) {
    /*background-color: #bbbbbb;*/
    color: #222;
  }

  .wrapper-estiva {
    width: 600px;
    display: grid;
    grid-gap: 1px;
    grid-template-columns: repeat(2, 100px);
  }


grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 75px;
  grid-gap: 10px;
}

grid-item {
  display: grid;            /* new */
  align-items: center;      /* new */
  justify-items: center;    /* new */
}

/* can ignore styles below; decorative only */
grid-container {
  background-color: lightyellow;
  border: 1px solid #bbb;
  padding: 1px;
}
grid-item {
  background-color: lightgreen;
  border: 1px solid #ccc;
}

 .wrapper-estiva .box  {
    padding: 0.15rem;
}


</style>

